<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow
      class="py-2 py-md-0"
    >

      <BCol
        cols="12"
      >
        <BRow class="gap-y-2">
          <BCol
            cols="12"
          >
            <LeadProfilePictures
              ref="leadProfilePictures"
              :loading="state.busy"
              :lead="leadProfile"
              @updated="changedProfile"
            />
          </BCol>

          <!-- LEAD INFORMATIONS -->
          <BCol
            cols="12"
          >
            <BOverlay
              :show="state.busy"
              opacity="0.5"
            >
              <BCard
                class="border min-h-550px"
              >
                <BCardText>
                  <BTabs
                    v-model="currentTabIndex"
                    nav-class="scrollable-x-tabs no-scrollbar nav-lead-tabs gap-x-1"
                    pills
                  >
                    <template #tabs-start>
                      <div class="nav-item">
                        <div
                          class="d-flex align-items-center position-absolute"
                          style="padding: 2px 1px; height: 38px;"
                        >
                          <i
                            class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
                            style="font-size: 20px;"
                          />
                        </div>
                      </div>
                    </template>
                    <template #tabs-end>
                      <div class="nav-item">
                        <div
                          class="d-flex align-items-center position-absolute"
                          style="right: 20px; padding: 2px 1px; height: 38px;"
                        >
                          <i
                            class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
                            style="font-size: 20px;"
                          />
                        </div>
                      </div>
                    </template>
                    <BTab>
                      <template #title>
                        <i :class="iconState('fa-file-user', currentTabIndex === 0)" /> Info
                      </template>

                      <BContainer
                        class="h-100 px-2"
                        fluid
                      >
                        <LeadInformations
                          ref="leadInformations"
                        />
                      </BContainer>
                    </BTab>
                  <!--
                    <BTab lazy>
                      <template #title>
                        <i :class="iconState('fa-file-zipper', currentTabIndex === 4)" /> Documents
                      </template>
                      <BContainer
                        class="h-100 p-0"
                        fluid
                      >
                        <LeadDocuments
                          ref="leadDocuments"
                          :lead="leadProfile"
                          @updated="updateDocuments"
                        />
                      </BContainer>
                    </BTab> -->
                  </BTabs>
                </BCardText>
              </BCard>
            </BOverlay>
          </BCol>

        </BRow>
      </BCol>
    </BRow>

    <BModal
      ref="modalDocument"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <div class="p-2 min-h-400px max-h-400px">
        <ValidationObserver
          ref="formDocument"
        >
          <form
            role="form"
            novalidate
            @submit.prevent
          >
            <BRow>
              <BCol
                cols="12"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  vid="document_type_id"
                  name="document type"
                  rules="required"
                >
                  <BFormGroup
                    label="Document Type"
                    label-for="fDocumentType"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fDocumentType"
                      v-model="formDocument.document_type_name"
                      placeholder="no selected document type"
                      disabled
                      :state="errors.length > 0 ? false : null"
                    />
                    <div
                      v-if="(errors.length > 0)"
                      class="invalid-feedback"
                      v-text="errors[0]"
                    />
                  </BFormGroup>
                </ValidationProvider>
              </BCol>
            </BRow>
          </form>
        </ValidationObserver>

        <LeadDocumentUploader
          ref="attachmentUploader"
          :path="formDocument.attachment_path"
          :files="formDocument.attachments"
          :loading="state.busy"
          :show-uploader="!state.editing"
          @onUploaded="updateFormDocument"
        />
      </div>
      <template #modal-footer="{ cancel }">
        <BButton
          v-if="!state.editing"
          variant="secondary"
          :disabled="state.busy || fetching.documentTypes"
          @click.prevent="validateDocument"
        >
          Mark As Verified
        </BButton>
        <BButton

          variant="outline-dark"
          :disabled="state.busy"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          {{ state.editing ? 'Close' : 'Discard' }}
        </BButton>
      </template>
    </BModal>
  </BContainer>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

import LeadProfilePictures from '@/views/asm/lead-management/ProfilePictures.vue'
import LeadInformations from '@/views/asm/lead-management/Informations.vue'
// import LeadDocuments from '@/views/asm/lead-management/documents/Base.vue'
import LeadDocumentUploader from '@/views/asm/lead-management/documents/Uploader.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'
import MDocumentTypes from '@/mixins/maintenances/document-types'

import { SASMLeadDocument } from '@/services/asm'

export default {
  name: 'VASMLeadManagement',

  components: {
    LeadDocumentUploader,
    LeadProfilePictures,
    LeadInformations
    // LeadDocuments
  },

  mixins: [
    MxMisc,
    MxFormatter,
    MDocumentTypes
  ],

  middleware: ['auth', 'asm'],

  metaInfo: () => ({
    title: 'Lead Management'
  }),

  data () {
    return {
      formErrors: {
        documents: []
      },
      state: {
        busy: false
      },
      currentTabIndex: 0,
      tasksCurrentTabIndex: 0,
      formDocument: {
        lead_id: '',
        document_type_id: '',
        document_type_name: '',
        attachment_path: '',
        attachments: [],
        active: 1
      },
      areaManager: {
        id: '',
        first_name: '',
        last_name: '',
        photo_url: ''
      },
      officer: {
        id: '',
        first_name: '',
        last_name: '',
        photo_url: ''
      },
      leadProfile: {
        id: '',
        lead_code: '',
        lead_name: '',
        contact_person: '',
        email: '',
        mobile_number: '',
        address: '',
        remarks: '',
        status: 'Verified',
        active: 1
      },
      formLeadProfilePicture: {
        file: null
      },
      leadAttachments: [],
      leadInteractions: [],
      leadTasks: []
    }
  },

  computed: Object.assign({
    isVerified () {
      return this.leadProfile.status === 'Verified'
    }
  },
  mapGetters({
    showLeadSuggestion: 'lead-management/showLeadSuggestionState',
    currentUser: 'auth/user'
  })),

  watch: {
    '$route.params.lead' () {
      this.getLeadProfile(true, false)
      this.currentTabIndex = 0
    },

    'selected.documentType' (documentType) {
      this.formDocument.document_type_id = documentType?.id || null
      this.formDocument.document_type_name = documentType?.document_type_name || null
    }
  },

  mounted () {
    if (this.currentUser) {
      this.getLeadProfile()

      this.$nextTick(() => {
        this.attachArrowScroller('.nav-lead-tabs')
      })
    }
  },

  destroyed () {
    this.detachArrowScroller('.nav-lead-tabs')
  },

  methods: {
    computedProfilePath (photoUrl) {
      return `${process.env.VUE_APP_API_BASE_URL}/${photoUrl}`
    },

    isFetchingInformationLocations () {
      if (this.$refs.leadInformations) {
        return this.$refs.leadInformations.isFetchingLocations()
      }

      return false
    },

    vTabDocuments () {
      return this.formErrors.documents.length > 0
    },

    resetDocumentErrors () {
      this.formErrors.documents = []
    },

    showOrHideLeadSuggestions () {
      this.showLeadSuggestions(!this.showLeadSuggestion)

      this.$nextTick(() => {
        if (this.showLeadSuggestion) {
          this.$refs.leadSuggestions.tableProvider()
        }
      })
    },

    setLeadProfile (lead) {
      this.formDocument = Object.assign(this.formDocument, {
        lead_id: lead.id,
        document_type_id: 1,
        document_type_name: 'Consent Form',
        attachment_path: '',
        attachments: [],
        active: 1
      })

      this.leadProfile = Object.assign(this.leadProfile, {
        id: lead.id,
        lead_code: lead.lead_code,
        lead_name: lead.lead_name,
        contact_person: lead.contact_person,
        email: lead.email,
        mobile_number: lead.mobile_number,
        address: lead.address,
        remarks: lead.remarks,
        active: lead.active
      })
    },

    async getLeadProfile (useLoader = true, useTableProvider = true) {
      this.state.busy = useLoader && true

      this.$refs.leadInformations.showInformation(this.$route.params.lead).then(
        async lead => {
          if (!lead) {
            return this.swalInvalid(
              '<h6>Your lead profile seems to be incorrect or incomplete, please check and try again.</h6>',
              'Lead Not Found'
            ).then(
              () => {
                this.$router.push({ name: 'asm.leads' })
              }
            )
          }

          this.areaManager = Object.assign(this.areaManager, {
            id: lead.verifier?.id,
            first_name: lead.verifier?.first_name,
            last_name: lead.verifier?.last_name,
            photo_url: lead.verifier?.photo_url
          })

          this.officer = Object.assign(this.officer, {
            id: lead.creator?.id,
            first_name: lead.creator?.first_name,
            last_name: lead.creator?.last_name,
            photo_url: lead.creator?.photo_url
          })

          this.$refs.leadInformations.editInformation(lead)
          this.setLeadProfile(lead)
        }
      ).finally(() => {
        this.state.busy = false
      })
    },

    updateInformation () {
      this.$refs.leadInformations.validateInformation().then(
        () => {
          this.swalConfirm({
            text: 'Update the Information of this Lead?',
            confirmButtonText: 'Update',
            cancelButtonText: 'Discard',
            preConfirm: async () => {
              return this.$refs.leadInformations.putInformation().catch(
                ({ message }) => {
                  if (message && message?.errors) {
                    this.$refs.leadInformations.setErrors(message.errors)
                  }
                }
              )
            }
          }).then(
            ({ value }) => {
              if (value?.lead && value?.message) {
                const { message, lead } = value
                this.swalSuccess(message).then(() => {
                  this.setLeadProfile(lead)
                })
              }
            }
          )
        }
      ).catch(() => {
        this.swalInvalid()
      })
    },

    changedProfile (leadPhoto) {
      this.leadProfile.photos = [leadPhoto]
    },

    updateDocuments (documents) {
      this.leadProfile.documents = [documents]
    },

    createDocument () {
      this.formDocument = Object.assign(this.formDocument, {
        id: null,
        lead_id: this.leadProfile.id,
        attachment_path: '',
        attachments: [],
        document_type_id: 1,
        document_type_name: 'Consent Form',
        active: 1
      })

      this.$refs.modalDocument.show()
    },

    updateFormDocument (attachment) {
      this.formDocument = Object.assign(this.formDocument, {
        attachment_path: attachment.attachment_path,
        attachments: attachment.attachments
      })
    },

    async validateDocument () {
      await this.$refs.formDocument.validate().then(
        async validDocument => {
          const noAttachments = this.formDocument.attachments.length === 0

          if (!validDocument || noAttachments) {
            if (noAttachments) {
              this.$refs.attachmentUploader.setErrors({
                attachments: ['Please upload at least one attachment.']
              })
            }

            return this.swalInvalid()
          }

          this.swalConfirm({
            text: 'Mark this Lead as Verified?',
            confirmButtonText: 'Mark as Verified',
            cancelButtonText: 'Discard',
            customClass: {
              confirmButton: 'btn btn-sm btn-secondary'
            },
            preConfirm: async () => {
              this.state.busy = true

              const createOrUpdate = async () => {
                return await this.postDocument()
              }

              return createOrUpdate().then(() => {
                this.$refs.leadInformations.setInformation({ status: 'Verified' })

                return this.$refs.leadInformations.putInformation().then(
                  ({ message, lead }) => {
                    this.swalSuccess(message).then(() => {
                      this.setLeadProfile(lead)
                      this.$refs.modalDocument.hide()
                    })
                  }
                ).catch(
                  ({ message }) => {
                    if (message && message?.errors) {
                      this.$refs.leadInformations.setErrors(message.errors)
                      this.$refs.leadInformations.setInformation({ status: 'New' })
                    }
                  }
                )
              }).catch(
                ({ message }) => {
                  if (message && message?.errors) {
                    this.$refs.attachmentUploader.setErrors(message.errors)
                    this.$refs.formDocument.setErrors(message.errors)
                  }
                }
              ).finally(() => {
                this.state.busy = false
              })
            }
          })
        }
      )
    },

    async postDocument () {
      return await SASMLeadDocument.post(this.formDocument).then(
        ({ data }) => data
      )
    },

    ...mapActions({
      showLeadSuggestions: 'lead-management/showLeadSuggestionAction'
    })
  }
}
</script>
